import React from "react";
import Main from "../components/Main";

const Home = ({ history }) => {
  return <Main />;
};

export default Home;
